export default __webpack_public_path__ + "static/media/project1.09b4f1c5.png";